/* eslint-disable max-len */
import 'react';

const DocRecommendDownSvg = () => (
    <svg width="10" height="10" xmlns="http://www.w3.org/2000/svg"><path d="M2.23 3.331h5.545a.5.5 0 01.386.818L5.389 7.516a.5.5 0 01-.772 0L1.845 4.15a.5.5 0 01.386-.818z" fill="#5C6473" opacity=".6" /></svg>
);

export default DocRecommendDownSvg;
